__webpack_require__.p = "/MomsCookbook/";